import { connect } from 'react-redux';

import ChecklistDeleteButton from './ChecklistDeleteButton';

import { showModal } from '../../../../actions/ModalActions';
import { unselectTask } from '../../../../actions/ChecklistActions';

import { getActiveTaskId } from '../../../../selectors/checklist/checklistSelectors';

const mapStateToProps = state => ({
  taskId: getActiveTaskId(state) || ''
});

const mapDispatchToProps = dispatch => ({
  deleteTask: (taskId) => {
    const callback = () => {
      dispatch(unselectTask());
    };
    return dispatch(showModal('DELETE_CHECKLIST_TASK_V2', { taskId, callback }, { size: 'sm' }));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ChecklistDeleteButton);



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistDeleteButton/index.js